import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { KineticLines, Reveal } from "@/components/Reveal";
import { IMG } from "@/lib/images";

const FRUITS = [
  { name: "Alphonso Mango", tag: "Summer", img: IMG.ripe.alphonso, imgM: IMG.ripe.alphonsoM, tid: "ripe-now-card-mango" },
  { name: "Strawberry", tag: "Winter", img: IMG.ripe.strawberry, imgM: IMG.ripe.strawberryM, tid: "ripe-now-card-strawberry" },
  { name: "Sitaphal", tag: "Monsoon", img: IMG.ripe.sitaphal, imgM: IMG.ripe.sitaphalM, tid: "ripe-now-card-sitaphal" },
  { name: "Tender Coconut", tag: "All Seasons", img: IMG.ripe.coconut, imgM: IMG.ripe.coconutM, tid: "ripe-now-card-coconut" },
];

export default function RipeNowStrip() {
  return (
    <section className="bg-deep py-16 md:py-24" data-testid="ripe-now-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-orange-rific md:text-xs">Ripe Now</p>
            </Reveal>
            <KineticLines
              lines={["WHAT'S RIPE NOW?"]}
              className="mt-4 block"
              lineClassName="font-display text-[clamp(2rem,4.2vw,3.25rem)] font-extrabold leading-[1.05] tracking-[-0.01em] text-cream"
            />
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.15}>
              <p className="max-w-md text-base leading-relaxed text-cream/80 md:text-lg">
                Good fruit has a season. We think ice cream should respect it.
              </p>
            </Reveal>
          </div>
        </div>

        <div
          className="mt-12 flex gap-5 overflow-x-auto pb-4 scrollbar-none snap-x snap-mandatory md:mt-16 md:grid md:grid-cols-4 md:gap-6 md:overflow-visible"
          data-testid="ripe-now-fruit-rail"
        >
          {FRUITS.map((f, i) => (
            <Reveal key={f.name} delay={i * 0.08} className="w-[85vw] max-w-[420px] shrink-0 snap-center md:w-auto md:max-w-none">
              <article data-testid={f.tid} className="h-full">
                <div className="overflow-hidden rounded-2xl bg-cream">
                  <img
                    src={f.img}
                    srcSet={`${f.img} 1536w, ${f.imgM} 800w`}
                    sizes="(min-width: 768px) 25vw, 85vw"
                    alt={`RIFIC ${f.name} ice cream — real fruit`}
                    loading="lazy"
                    className="h-auto w-full object-contain"
                  />
                </div>
                <div className="mt-4 flex items-center justify-between gap-2 px-1">
                  <h3 className="font-display text-xl font-bold uppercase tracking-[-0.01em] text-cream md:text-2xl">{f.name}</h3>
                  <span className="shrink-0 rounded-full bg-orange-rific px-3 py-1 font-mono text-[10px] uppercase tracking-[0.14em] text-white">
                    {f.tag}
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-14 md:mt-20">
          <div className="flex flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-left">
            <p className="font-display text-2xl font-bold tracking-[-0.01em] text-cream md:text-3xl">
              TASTE HAS A SEASON. <span className="text-orange-rific">WE PICK IT RIPE. WE MAKE IT RIFIC.</span>
            </p>
            <Link
              to="/ripe-now"
              data-testid="ripe-now-discover-cta"
              className="inline-flex h-12 shrink-0 items-center gap-2 rounded-full bg-orange-rific px-7 text-xs font-bold uppercase tracking-[0.16em] text-white transition-colors duration-300 hover:bg-cream hover:text-deep"
            >
              Discover Ripe Now
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
